let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("5eKPt")).then(() => parcelRequire('cyXr6'));